module.exports = flarum.core.compat['tags/components/TagLinkButton'];